import React from 'react';

const Profile2UserIcon: React.FC<{ size?: number }> = ({ size = 25 }) => (
  <svg width={size} height={size} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.65957 11.37C9.55957 11.36 9.43957 11.36 9.32957 11.37C6.94957 11.29 5.05957 9.34 5.05957 6.94C5.05957 4.49 7.03957 2.5 9.49957 2.5C11.9496 2.5 13.9396 4.49 13.9396 6.94C13.9296 9.34 12.0396 11.29 9.65957 11.37Z"
      stroke="#6C737F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9103 4.5C18.8503 4.5 20.4103 6.07 20.4103 8C20.4103 9.89 18.9103 11.43 17.0403 11.5C16.9603 11.49 16.8703 11.49 16.7803 11.5"
      stroke="#6C737F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.65973 15.06C2.23973 16.68 2.23973 19.32 4.65973 20.93C7.40973 22.77 11.9197 22.77 14.6697 20.93C17.0897 19.31 17.0897 16.67 14.6697 15.06C11.9297 13.23 7.41973 13.23 4.65973 15.06Z"
      stroke="#6C737F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8398 20.5C19.5598 20.35 20.2398 20.06 20.7998 19.63C22.3598 18.46 22.3598 16.53 20.7998 15.36C20.2498 14.94 19.5798 14.66 18.8698 14.5"
      stroke="#6C737F"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Profile2UserIcon;
